module.exports = __webpack_public_path__ + "static/img/gaozhongdili4.0745f735.jpg";